import { ControllerRenderProps, Select, SelectChangeEvent } from '@otp/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AppArea } from 'src/graphql/generated/graphql';

type AppAreaProps = {
  field: ControllerRenderProps<any, 'appArea'>;
  hasError: boolean;
  className?: string;
  disabled?: boolean;
  onChange?: (event: SelectChangeEvent) => void;
};

export const AppAreaField = ({
  field,
  hasError,
  className,
  disabled = false,
  onChange,
}: AppAreaProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'permissions.form.fields.app-area-options',
  });

  const options = useMemo(
    () =>
      Object.values(AppArea).map((item) => {
        return { value: item, name: t(item.toLowerCase()) };
      }),
    [t],
  );

  const defaultValue = field.value;

  return (
    <Select
      key={field.value}
      fullWidth={true}
      className={className}
      options={options}
      placeholder={t('placeholder')}
      defaultValue={defaultValue}
      error={hasError}
      {...field}
      value={undefined}
      ref={undefined}
      inputRef={field.ref}
      disabled={disabled}
      onChange={onChange}
    />
  );
};
